import { Grid, Box } from '@mui/material'; 
import london from '../assets/images/london.jpg'
import { useTheme } from '@mui/material/styles';
import  useMediaQuery  from '@mui/material/useMediaQuery';
const Hero = () => {
const theme = useTheme();
const matchesLG = useMediaQuery(theme.breakpoints.down('lg')); 
const dynamicStyles = {
	...matchesLG && {padding: '0px'} 
}
return (
<div>
<Grid container  className="heroGrid">
	{/* Left */}
	<Grid item 
				md={12}	lg={6}  
				sx={{...dynamicStyles}} 
			  className="heroGridLeft">

    <div className='image-wrapper'>
		<Box 
				component='img'
				alt="London, England"
        src={london}>
		</Box>
		<span className="chip-text chip-yellow">international</span>
		</div>
	</Grid> 

	{/* Right */}
	<Grid item 	 md={12}	lg={6} className="heroGridRight" > 
		<Box bgcolor='white' >
				<div className="content_area" >
					<h5>
							REGISTER NOW
					</h5>
					<h2>London, England</h2>
					<h5 className="small-dark">
							APRIL 15, 2020
					</h5>
					<p className='hero-p'>Ut placet, inquam tum dicere exorsus est laborum et via procedat oratio quaerimus igitur, quid et caritatem, quae sine causa? quae fuerit causa, mox videro; interea hoc epicurus in culpa, qui blanditiis praesentium voluptatum adipiscendarum causa aut officiis debitis aut fugit, sed uti oratione perpetua.</p>
				</div>
		</Box>
	</Grid> 	
</Grid>


</div>)}
export default Hero